import http from './index'

export default {
  base: {
    wxConfig: data => http.post(`/web/wechat/getJsconfig`, data),
    // 获取验证码
    sendCode: data => http.post(`/web/account/1/getMessageCode`, data),
    // 登录
    login: data => http.post(`/web/account/1/user/login`, data),
    // 获取医生信息
    getDoctorInfo: id => http.get(`/web/doctor/doctor/personalData?id=${id}`),
    // 获取COS 配置
    getCOSTempSign: data => http.post(`${process.env.VUE_APP_BASE_URL}/patient/oss/cpnt/getCosStsToken`, data),
    // 人脸识别
    faceRecognition: data => http.put(`/web/sys/attestation`, data),
    faceRecognitionV2: data => http.put(`https://component.doctorworking.cn/cpnt/esig/miniFace?name=${data.name}&idNumber=${data.idNumber}&redirectUrl=${data.sigUrl}&pj_code=1&callbackUrl=${data.callbackUrl}`),
    // 检查是否支持人脸识别
    isMiniFace: idNumber => http.get(`/web/sys/isMiniFace?idNumber=${idNumber}`),
    // 获取人脸识别状态
    getFaceStatus: doctorId => http.get(`https://marketing-server.zetta-yotta.com/sys/feign/meeting/getDoctorNeedFaceRecognition?doctorId=${doctorId}`),
    // 查询是否人脸识别
    getFaceRecognition: idCard => http.get(`/web/sys/isMiniFace?idNumber=${idCard}`),
    // 获取人脸识别链接
    getFaceRecognitionUrl: data => http.put('/web/sys/attestation', data)
  },
  meeting: {
    // 根据医生ID查询协议签署情况
    getDoctorAgreementStatus: data => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/meeting/getDoctorAgreementStatus`, data),
    // 获取活动劳务协议富文本
    getMeetingAgreementContent: data => http.get(`${process.env.VUE_APP_BASE_DM_URL}/represent/me/meeting/getSpeakerAgreementContent/${data.id}`, data),
    // 获取活动讲者信息
    getMeetingSpeakerInfo: data => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/meeting/getMeetingSpeakerInfo/${data.meetingId}/${data.doctorId}`, data),
    // 上传劳务协议
    uploadLaborAgreement: data => http.post(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/meeting/uploadLaborAgreement`, data),
    // 查询医生签署的历史协议
    getDoctorSignPictureByMeetingSpeakerId: meetingSpeakerId => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/meeting/getDoctorSignPictureByMeetingSpeakerId/${meetingSpeakerId}`),
  },
  work: {
    // 作品详情
    detail: data => http.get(`/web/works/${data.id}`, data),
    // 资讯内容详情
    inforDetail: data => http.get(`/web/home/information/${data.id}`),
    // i分身详情
    ifenshenInfoWork: id => http.get(`/web/queryVideoInfoByWorkId/${id}?browseNumber=1`),
    // i分身详情
    ifenshenInfo: id => http.get(`/web/queryVideoInfoById/${id}?browseNumber=1`),
    // 是否点赞
    getIsLike: id => http.get(`/web/works/${id}/isLike`),
    // 点赞
    likeArticle: (id) => http.get(`/web/works/${id}/giveALike`),
    // 录课详情
    dmDetailLuk: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/luk/${id}`),
    // 临床、调研详情
    dmDetailQuestion: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/questionnaireanswer/${id}`),
    // 文章创作活动
    dmDetailArticle: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/ecarticel/${id}`),
    // i分神
    dmDetailFenshen: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/ifenshen/${id}`),
    // 文献
    dmDetailWenxian: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/literaturedoctor/${id}`),
    // 点评
    dmDetailDianping: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/yelp/doctor/${id}`),
    // 征集
    dmDetailCollect: (id) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/link/collect/${id}`),
	// 获取作品完成时间
	dmGetDoneTime: (id, type) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/order/completeTime/${id}/${type}`),
  },
  course: {
    // 活动详情
    detail: data => http.get(`${process.env.VUE_APP_BASE_URL_LIVE}/microWebsite/api/getContentInfo/${data.id}`),
    // 生成支付订单
    getPayOrder: data => http.post(`${process.env.VUE_APP_BASE_URL_LIVE}/microWebsite/pay/zettaPayOrder`,data),
    // 获取封装参数
    getCustomerServiceInfo: data => http.post(`/web/wxcode/getCustomerServiceInfo`,data)
  },
   // 活动
  activity: {
    // 检测科室是否允许创建
	  checkTitle: (doctorId, activityId, taskType) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/task/checkTitle/${doctorId}/${activityId}/${taskType}`),
    // 判断活动进度状态
    checkActivityStatus: (data) => http.get('/web/taskStatus', data),
    // 检查任务可创作数量(0、可创作 1、暂存已占用次数达到上限、2、达到上限)
    checkTaskCount: (data) => http.get(`/web/works/checkTaskCount`, data),
    // 获取大麦活动信息
    getDmActivity: (data) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/projects/getByActivityId/${data.activityId}`, data),
  },
  surveys: {
	  // 检测科室是否允许创建
	  checkTitle: (doctorId, activityId, taskType) => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/task/checkTitle/${doctorId}/${activityId}/${taskType}`),
    // i 调研列表
    page: data => http.post(`/web/surveys`, data),
    // i 调研列表的表单类型
    formTypePage: data => http.get(`/web/surveys/${data.surveyId}/forms`, data),
    // 表单详情
    formDetail: id => http.get(`/web/surveys/forms/${id}`),
    // 调研详情
    surveysDetail: (id, data = {}) => http.get(`/web/surveys/${id}`, data),
    // 作答-提交
    submitAnswer: data => http.post(`/web/surveys/answers`, data),
    // 作答-分页
    asnwerPage: data => http.get(`/web/surveys/answers`, data),
    // 作答-详情
    asnwerDetail: id => http.get(`/web/surveys/answers/${id}`),
    // 作答-修改
    asnwerUpdate: data => http.put(`/web/surveys/answers/${data.id}`, data),
    // 检测是否包含ocr
    checkOcr: data => http.post(`/web/sys/ocr`, data),
    // 医生随访列表
    followPage: data => http.get(`/web/follow/answer`, data),
    // 医生随访详情
    followDetail: id => http.get(`/web/follow/answer/${id}`),
    // 随访提交
    followSubmitForm: data => http.put(`/web/follow/answer`, data),
    // 更新医生邮箱
    updateUserEmail: data => http.put(`/web/surveys/answers/ppt/email`, data),
    // 发送PDF到邮箱
    sendEmailForQuePDF: data => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/questionAnswer/cav/sendEmailForQuePDF/${data.id}`, data),
    // 获取执行详情
    questionAnswerCav: id => http.get(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/questionAnswer/cav/list/${id}`),
    // 保存执行
    saveQuestionAnswerCav: data => http.post(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/questionAnswer/cav/${data.id}`, data.list),
    getRecognizeCodes: data => http.get(`/web/surveys/answers/getRecognizeCodes`,data),
	// 获取OCR识别结果
	submitOCR: data => http.post(`https://gateway.doctorworking.cn/common-service/common/image/freeOcr`, data),
	// 获取PPT URL
	getPPTUrl: data => http.put(`/web/surveys/answers/ppt/getPptUrl`, data),
  },
  redBracelet: {
    // 检测是否包含ocr
    getRankingList: data => http.post(`/web/ranking/list`, data),

  },
  user: {
    // 获取验证码
    getSmsCode: data => http.post(`web/account/1/getMessageCode`, data),
    // 登录
    login: data => http.post(`/web/account/1/user/login`, data),
    // 获取鉴权code
    getAuthCode: doctorId => http.get(`/blockchain/chain/authcode/${doctorId}`),
    // 获取用户信息
    getUserInfo: params => http.get(`/web/doctor/doctor/personalData`, params),
  },
  liveForm: {
    // 直播表单
    getViewQuestionContent: data => http.post(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/meeting/viewQuestionContent`, data),
    saveViewQuestionContent: data => http.post(`${process.env.VUE_APP_BASE_DM_URL}/sys/feign/meeting/saveViewQuestionContent`, data),
  }
}
